webpackJsonp([302],{

/***/ 1053:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "VUX V2.3.5 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1868:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1053),
  /* template */
  __webpack_require__(2411),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/v2.3.5-233.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] v2.3.5-233.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a15289d6", Component.options)
  } else {
    hotAPI.reload("data-v-a15289d6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2411:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.3.5 发布日志")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/actionsheet.html"
    }
  }, [_vm._v("Actionsheet")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持 slot:header #1381")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/inline-calendar.html"
    }
  }, [_vm._v("InlineCalendar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持自定义每一天的 html 渲染 slot:each-day")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/radio.html"
    }
  }, [_vm._v("Radio")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持自定义渲染每一列 slot:each-item")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/search.html"
    }
  }, [_vm._v("Search")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 增加 slot:left")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/swiper.html"
    }
  }, [_vm._v("Swiper")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复重复渲染问题 #1458")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/tab.html"
    }
  }, [_vm._v("Tab")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持设置 badge #1513")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a15289d6", module.exports)
  }
}

/***/ }),

/***/ 676:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1868);

/***/ })

});


// WEBPACK FOOTER //
// 302.49ae2bed.js